import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';

// Initialize theme before render to avoid flash
import { useThemeStore } from '@/store/themeStore';
const theme = useThemeStore.getState().theme;
const prefersDark = theme === 'system'
  ? window.matchMedia('(prefers-color-scheme: dark)').matches
  : theme === 'dark';
document.documentElement.classList.toggle('dark', prefersDark);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,       // 5 min
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

const basename = import.meta.env.BASE_URL === '/' ? undefined : import.meta.env.BASE_URL.replace(/\/+$/, '');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={basename}>
          <App />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                borderRadius: '0.75rem',
                fontSize: '0.875rem',
                background: prefersDark ? '#242428' : '#fff',
                color: prefersDark ? '#e2e8f0' : '#1e293b',
                border: prefersDark ? '1px solid #334155' : '1px solid #e2e8f0',
              },
            }}
          />
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
